import { useSelector } from 'react-redux';
import filter from 'ramda/src/filter';
import values from 'ramda/src/values';
import { extendMoment } from 'moment-range';
import originalMoment from 'moment';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Rating from '@components/@core/Rating';
import EditDropdown from '@components/EditDropdown';
import { CompanyPerformanceReportMenu } from '~/services/config';

const moment = extendMoment(originalMoment);

const EmployeeList = ({ onReport, onSelectMenu, onPagination, onPer }) => {
    const role = useSelector((state) => state.app.app_role_id);
    const data = useSelector((state) => state.manage.companyPerformanceReviews);

    return (
        <>
            <div className="list-title mt-2 pb-2 ps-0 desktop-screen">
                <div className="d-flex-4">
                    <span className="dsl-m12">Employee</span>
                </div>
                <div className="d-flex-4">
                    <span className="dsl-m12">Scorecard</span>
                </div>
                <div className="d-flex-1 d-none d-md-block" />
                <div className="d-flex-3 ms-1 ms-md-0">
                    <span className="dsl-m12">Score</span>
                </div>
                <div className="d-flex-2 d-flex-ssm-3 me-2 me-md-0">
                    <span className="dsl-m12">Tasks & Training</span>
                </div>
                <div className="d-flex-2 d-flex-ssm-3 text-end">
                    <span className="dsl-m12">Completed</span>
                </div>
                <div className="d-flex-1" />
            </div>
            {data.users.length > 0 ? (
                <>
                    {data.users.map((item, index) => {
                        const { performance, user, scorecards } = item;
                        let editOptions = [];
                        if (scorecards?.length === 0) {
                            editOptions = filter((e) => e !== 'Unassign Scorecard' && e !== 'Preview Scorecard' && e !== 'Start Review' && e !== 'Save Actuals', CompanyPerformanceReportMenu[role]);
                        } else {
                            editOptions = filter((e) => e !== 'Assign Scorecard', CompanyPerformanceReportMenu[role]);
                        }
                        if (performance?.status === 2) {
                            editOptions = filter((e) => e !== 'Save Actuals' && e !== 'Start Review', editOptions);
                        }
                        return (
                            <div key={index} className="d-flex ssm-column py-3 list-item">
                                <div className="d-flex-4 d-flex ai-center jc-between w-100">
                                    <div className="d-flex ai-center jc-between">
                                        <Avatar name={`${user?.profile?.first_name} ${user?.profile?.last_name}`} url={user?.avatar} />
                                        <div className="dsl-b14 mx-3 cursor-pointer text-break" onClick={() => onReport(item)}>
                                            {user?.profile?.first_name + ' ' + user?.profile?.last_name}
                                        </div>
                                    </div>
                                    <EditDropdown className="mobile-screen" options={editOptions} onChange={onSelectMenu(item)} />
                                </div>
                                <div className="d-flex-4 truncate cursor-pointer w-100" onClick={() => onReport(item)}>
                                    <label className="dsl-b14 mobile-screen w-30">Scorecard</label>
                                    <span className="dsl-b14">
                                        {performance?.status == 2 ? values(performance?.data?.scorecards)[0]?.title : scorecards?.length > 0 ? scorecards[0]?.title : 'No Scorecard Assigned'}
                                    </span>
                                </div>
                                <div className="d-flex-1 d-none d-md-block" />
                                <div className="d-flex-3 w-100">
                                    <label className="dsl-b14 mobile-screen w-30">Score</label>
                                    {performance?.status === 2 ? (
                                        <>
                                            {performance?.data?.completed_average_star_rating === 'N/A' ? (
                                                <span className="dsl-b14">Na (Per Manager)</span>
                                            ) : (
                                                <Rating score={performance?.data?.completed_average_star_rating} />
                                            )}
                                        </>
                                    ) : (
                                        <span className="dsl-b14">Incomplete</span>
                                    )}
                                </div>
                                <div className="d-flex-2 w-100">
                                    <label className="mobile-screen dsl-b14 w-30">Task & Training</label>
                                    {performance?.status === 2 && scorecards?.length > 0 ? (
                                        <>
                                            <Icon name="fas fa-graduation-cap" color="#343f4b" size={14} />
                                            <span className="dsl-b14 ms-1">{performance?.trainings?.length},</span>
                                            <Icon name="fas fa-circle-check ms-2" color="#343f4b" size={14} />
                                            <span className="dsl-b14 ms-1">{performance?.tasks?.length}</span>
                                        </>
                                    ) : (
                                        <span className="dsl-b14">N/A</span>
                                    )}
                                </div>
                                <div className="d-flex-2 text-end ssm-left w-100">
                                    <label className="mobile-screen dsl-b14 w-30">Completed</label>
                                    {performance?.status == 2 ? <span className="dsl-b14">{moment(performance?.completed_at).format('MMM DD, YY')}</span> : <span className="dsl-b14">Incomplete</span>}
                                </div>
                                <div className="d-flex-1 text-end pt-1 desktop-screen">
                                    <EditDropdown options={editOptions} onChange={onSelectMenu(item)} />
                                </div>
                            </div>
                        );
                    })}
                    <Pagination current={data.page} total={data.last_page} per={data.per_page} onChange={onPagination} onPer={onPer} />
                </>
            ) : (
                <p className="dsl-m12 text-center my-5">No records available</p>
            )}
        </>
    );
};

export default EmployeeList;
